import React from 'react';
import styles from './TopbarComponent.module.css';
import logo from '../../assets/SVG/fertility_care2.svg';
import MuiBreadcrumbs from '../breadcrumbComponent';
import DefaultImageMale from '../../assets/SVG/Default Profile - Male.svg';
import { Avatar, Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import UserSettingsComponent from '../userSettingsComponent';
import { DrawerComponent } from '../drawerComponent';
import { Clinic, User } from '../../types';
import { convertUnderscoreToTitle } from '../../utils/commonUtils';
import SessionTimeoutBar from './SessionTimeoutBar';
import { useSessionTimeout } from './useSessionTimeout';

interface TopBarProps {
  handleChange: (event: SelectChangeEvent) => void
  user: User
  clinic: string
}

const TopBarComponent: React.FC<TopBarProps> = ({handleChange, user, clinic}) => {
  
  // Session timeout management
  const { remainingTime, isBufferPeriod, timeoutMinutes, warningMinutes } = useSessionTimeout();

  return (
    <div className={styles.bar}>
      <div className={styles.drawer}>
        <DrawerComponent />
      </div>
      <div className={styles.logo_container}>
        <img src={logo} alt="logo" />
      </div>
      <div className={styles.bd_container}>
        <MuiBreadcrumbs />
        <div className={styles.end}>
          <div>
            {user && <Typography variant="body1" color="textPrimary">{user.tenant?.name}</Typography>}
          </div>
          <div>
            <FormControl 
              variant="filled"
              sx={{
                m: 1,
                minWidth: 120,
                fontSize: '1rem',
                '& .MuiFilledInput-root': {
                  backgroundColor: '#e0e0e0', // optional, for background
                  borderBottom: 'none', // removes the underline
                  boxShadow: 'none', // removes shadow
                },
                '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
                  borderBottom: 'none', // removes underline before/after focus
                },
              }}>
              <InputLabel id="demo-simple-select-filled-label">Clinic</InputLabel>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={clinic}
                onChange={handleChange}
              >
                {user?.clinics.map((clinic: Clinic) => (
                  <MenuItem key={clinic.clinic_id} value={clinic.clinic_id}>
                    {clinic.clinic__name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/*
            2025-08-18
            Temporarily removed due to user permission restrictions.
            Uncomment and restore when permissions are resolved.
          */}            
          {/* 
          <div className={styles.icons}>
            <div className={styles.icn_container}>
              <img onClick={() => {navigate('/admin/appointments');}} src={calander} alt="calendar" />
            </div>
          </div> 
          */}
          {/* END */}

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className={styles.profile}>
              {user && <Avatar alt={user.username} src={user.photo || DefaultImageMale} />}
              <div>
                {user && <UserSettingsComponent user={user} />}
                {user && <Typography sx={{fontFamily: 'Nunito'}} variant="caption" color="textSecondary">{convertUnderscoreToTitle(user.designation || '')}</Typography>}
              </div>
            </div>
            
            {/* Session Timeout Progress Bar - Only shows after buffer of inactivity */}
            {!isBufferPeriod && (
              <SessionTimeoutBar
                remainingTime={remainingTime}
                totalMinutes={timeoutMinutes}
                warningMinutes={warningMinutes}
              />
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default TopBarComponent;